<template>
  <ion-page>
    <ion-content :fullscreen="true">
      <div class="row">
        <HeaderComp currentPage="about"></HeaderComp>

        <ValuesContent class="text-black" />

        <FooterComp></FooterComp>
      </div>
    </ion-content>
  </ion-page>
</template>
<script>
import HeaderComp from '@/components/layouts/HeaderComp'
import FooterComp from '@/components/layouts/FooterComp'
import ValuesContent from '@/views/content/ValuesContent'
import { IonContent, IonPage } from '@ionic/vue';
export default {
  components: { ValuesContent, FooterComp, HeaderComp, IonContent, IonPage },
  data() {
    return {}
  },
}
</script>
